module.exports = __webpack_public_path__ + "img/search.a1bddf6b.svg";